import { Expose } from "class-transformer";

export class Candidate {
  @Expose({ name: "candidateId" })
  CandidateId?: string;

  @Expose({ name: "fullName" })
  FullName?: string;

  @Expose({ name: "mobilePhone" })
  MobilePhone?: string;

  @Expose({ name: "stateCode" })
  StateCode?: number;

  @Expose({ name: "emailAddress" })
  EmailAddress?: string;

  @Expose({ name: "cityId" })
  CityId?: string;

  @Expose({ name: "gender" })
  Gender?: number;

  @Expose({ name: "birthDate" })
  BirthDate?: Date;

  constructor(
    candidateId?: string,
    fullName?: string,
    mobilePhone?: string,
    stateCode?: number,
    emailAddress?: string,
    cityId?: string,
    gender?: number,
    birthDate?: string
  ) {
    this.CandidateId = candidateId;
    this.FullName = fullName;
    this.MobilePhone = mobilePhone;
    this.StateCode = stateCode;
    this.EmailAddress = emailAddress;
    this.CityId = cityId;
    this.Gender = gender;
    this.BirthDate = birthDate ? new Date(birthDate) : undefined;
  }
}
